import styled, { css } from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
import { Button } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const DesktopSidebarWrapper = styled('nav')`
  width: ${({ theme }) => theme.sidebarWidth}px;
`;

interface ListItemProps {
  selected?: boolean;
}

export const ListItem = styled('li')<ListItemProps>`
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  position: relative;
  ${media.lgUp`
    width: 230px;
  `}
  ${media.xlUp`
    width: 267px;
  `}
  border-radius: 4px;
  ${({ selected }) =>
    selected &&
    css`
      a {
        color: ${({ theme }) => theme.color.white};
      }
      background-color: ${({ theme }) => theme.color.noir};
      &:before {
        content: '';
        display: block;
        position: absolute;
        width: ${({ theme }) => theme.x1spacePx / 2}px;
        height: 100%;
        top: 0;
        background: ${({ theme }) => theme.color.brand01};
        border-radius: 4px;
      }
      body[data-theme] & {
        a {
          color: var(--s-color-text-solid);
        }
        background-color: var(--s-color-surface-1);
        &:before {
          background: var(--s-color-brand-01);
        }
      }
    `};
  &:hover {
    background-color: ${({ theme }) => theme.color.noir};
  }

  body[data-theme] & {
    color: var(--s-color-text-softer);
    &:hover {
      background-color: var(--s-color-surface-1);
    }
  }
`;

const navCSS = css`
  padding: 4px 0 4px 18px;
  height: auto;

  ${({ theme }) => theme.typography.small};
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};

  body[data-theme] & {
    color: var(--s-color-text-softer);
  }

  ${media.lgUp`
    width: 230px;
  `}
  ${media.xlUp`
    width: 267px;
  `}
  &:hover {
    background-color: transparent;
  }
  label {
    padding-right: 10px;
  }
`;

export const NavButton = styled(Button)`
  ${navCSS}
`;

export const NavLinkSplit = styled(RouterLink)`
  display: block;
  text-decoration: none;
  ${navCSS}
`;
